import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import {
  ApplicationsRequest,
  ApplicationsResponse,
  ApplicationViewResponse,
  ApplicationViewRequest,
  ApplicationCreateRequest,
  ApplicationCreateResponse,
  ApplicationUpdateRequest,
  ApplicationUpdateResponse,
  ApplicationManageChannelRequest,
  ApplicationManageChannelResponse,
} from "./types";
import { Application } from "../../model/applications";

const defaultApplicationsExpand: Array<keyof Omit<Application, "id">> = [
  "name",
  "customer",
  "project",
  "legal_entity",
  "department",
  "profile",
  "candidate_grade",
  "job_duties",
  "job_format",
  "job_workload",
  "attraction_period",
  "sales_max_offer_general",
  "sales_max_offer_regions",
  "sales_max_offer_moscow",
  "bitrix_contract_link",
  "purchase_rate_max",
  "candidate_requirements",
  "project_description",
  "bitrix_contract_link",
  "sales_max_offer_regions",
  "sales_max_offer_moscow",
  "purchase_rate_max",
  "required_number",
  "location",
  "job_format",
  "office_address",
  "job_workload",
  "attraction_period",
  "comments",
  "attachments",
  "location",
  "marginality",
  "location",
  "required_number",
  "attachments",
  "comments",
  "project_description",
  "office_address",
  "created_at",
  "created_by",
  "status",
  "channels",
  "can_edit",
  "can_manage_channel",
  "vacancy",
];

export const applications = (data?: ApplicationsRequest): AxiosPromise<ApplicationsResponse> => {
  const { limit, offset, search, sort_column, sort_direction, ...rest } = data?.params?.filters || {};
  return axiosInstance.get(
    `/applications?expand=${data?.params?.expand?.length ? data?.params?.expand?.join(",") : defaultApplicationsExpand.join(",")}`,
    {
      params: {
        limit,
        offset,
        search,
        sort_column,
        sort_direction,
        ...rest,
      },
    },
  );
};

export const applicationView = (data: ApplicationViewRequest): AxiosPromise<ApplicationViewResponse> =>
  axiosInstance.get(
    `/application/${data.params.id}/view?expand=${data?.params?.expand?.length ? data?.params?.expand?.join(",") : defaultApplicationsExpand.join(",")}`,
  );

export const applicationManageChannel = (data: ApplicationManageChannelRequest): AxiosPromise<ApplicationManageChannelResponse> =>
  axiosInstance.post(`/application/${data.params.id}/manage-channel`, data.body);

export const applicationCreate = (data: ApplicationCreateRequest): AxiosPromise<ApplicationCreateResponse> =>
  axiosInstance.post(`/application/create`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const applicationUpdate = (data: ApplicationUpdateRequest): AxiosPromise<ApplicationUpdateResponse> =>
  axiosInstance.post(`/application/${data.params.id}/update`, data.body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
